/** Shared 2D/3D dimension token for the physics linter-rule factories. */
/** Lowercase suffix used in rule names, for example `area2d` and `rigidbody3d`. */
export function dimSuffix(dim) {
    return dim.toLowerCase();
}
//# sourceMappingURL=dim.js.map